import React, { Suspense, useCallback, useState } from 'react';
import { useLocation } from 'react-router';

import { useQueryMe } from 'gql/queries/me';

const Onboarding = React.lazy(() => import('./Onboarding'));

const OnboardingContainer = () => {
  const location = useLocation();
  const isInTeamsConfigure = location.pathname === '/ms-teams/configure';
  const [activeStep, setActiveStep] = useState(0);
  const handleStepNext = useCallback(() => {
    setActiveStep((tab) => tab + 1);
  }, []);
  const { isLoading, data } = useQueryMe();
  const isOnboarded = isLoading ? true : data.me.tags.includes('onboarded');
  const isTourDone = isLoading ? true : data.me.tags.includes('tour:3');
  return (
    !isTourDone &&
    !isInTeamsConfigure && (
      <Suspense fallback={null}>
        <Onboarding
          activeStep={activeStep}
          handleStepNext={handleStepNext}
          isOnboarded={isOnboarded}
          me={data.me}
        />
      </Suspense>
    )
  );
};

export default OnboardingContainer;
